import { FormattedMessage } from '@alltrails/shared/react-intl';
import { useEffect } from 'react';
import Button from '@alltrails/shared/denali/components/Button';
import logExploreWithProButtonClicked from '@alltrails/analytics/events/logExploreWithProButtonClicked';
import logProWelcomePageViewed from '@alltrails/analytics/events/logProWelcomePageViewed';
import CustomProvider from 'components/CustomProvider';
import { wrapUrlSafe } from 'utils/language_support_util';
import useLanguageRegionCode from 'hooks/useLanguageRegionCode';
import * as styles from './ProWelcome.module.scss';

type Props = {
  isAuthed: boolean;
};

function ProWelcome({ isAuthed }: Props) {
  const languageRegionCode = useLanguageRegionCode();

  useEffect(() => {
    logProWelcomePageViewed();
  }, []);

  // could be a shared function
  const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
  const buttonPath = isAuthed ? '/explore' : '/login';
  const buttonDestination = wrapUrlSafe(`${buttonPath}?ref=pro-welcome`, languageRegionCode);

  return (
    <CustomProvider>
      <div className={styles.proWelcome}>
        <section>
          <div className={styles.welcomeText}>
            <h1 className={styles.heading}>
              <FormattedMessage defaultMessage="Welcome to {pro}." values={{ pro: <span className={styles.welcomeProBadge} /> }} />
            </h1>
            <p className={styles.welcome}>
              <FormattedMessage defaultMessage="You're an official Pro subscriber." />
              <br />
              <FormattedMessage defaultMessage="Welcome to our community of outdoor enthusiasts just like you." />
            </p>
            {isMobile ? (
              <p className={styles.mobile}>
                <FormattedMessage defaultMessage="For the best experience, download the AllTrails app or visit alltrails.com on a desktop computer." />
              </p>
            ) : (
              <Button
                text={<FormattedMessage defaultMessage="Start Exploring with Pro" />}
                linkInfo={{ href: buttonDestination }}
                onClick={logExploreWithProButtonClicked}
                testId="pro-welcome-start-exploring"
                variant="primary"
              />
            )}
          </div>
          <div className={styles.topImage} />
        </section>
      </div>
    </CustomProvider>
  );
}

export default ProWelcome;
